/**
 * Galería móvil de la ficha de producto: carrusel + miniaturas.
 *
 * El tema trae dos modos de galería en móvil que no se mezclan:
 *   - "Miniaturas": se ve una sola foto y hay que picarle a la miniatura
 *     (no se puede deslizar).
 *   - "Carrusel": Swiper, se desliza con el dedo, pero sólo muestra puntitos.
 *
 * El ajuste "Carrusel + miniaturas" renderiza el carrusel nativo y, debajo y
 * fuera del contenedor de Swiper, la tira de miniaturas. Este archivo es el
 * puente entre los dos: click en miniatura -> slideTo, y cambio de slide ->
 * miniatura activa.
 */
(function () {
  'use strict';

  var THUMBS = '[data-carousel-thumbs]';
  var THUMB = '[data-product-thumbnail]';

  function slideIndexForMedia(swiper, mediaId) {
    var slides = swiper.slides;

    for (var i = 0; i < slides.length; i++) {
      if (slides[i].dataset.mediaItemId === String(mediaId)) {
        // Con loop activado los índices reales no coinciden con los del DOM.
        return swiper.params.loop ? i : parseInt(slides[i].dataset.slideIndex, 10) || i;
      }
    }

    return -1;
  }

  function markActive(thumbsEl, mediaId) {
    thumbsEl.querySelectorAll(THUMB).forEach(function (btn) {
      var isActive = btn.dataset.thumbnailId === String(mediaId);
      btn.classList.toggle('active', isActive);

      if (isActive && btn.parentElement) {
        btn.parentElement.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
    });
  }

  function connect(thumbsEl, swiper) {
    thumbsEl.addEventListener('click', function (event) {
      var btn = event.target.closest(THUMB);
      if (!btn) return;

      var index = slideIndexForMedia(swiper, btn.dataset.thumbnailId);
      if (index < 0) return;

      if (swiper.params.loop && swiper.slideToLoop) {
        swiper.slideToLoop(index);
      } else {
        swiper.slideTo(index);
      }
    });

    var sync = function () {
      var slide = swiper.slides[swiper.activeIndex];
      if (slide) markActive(thumbsEl, slide.dataset.mediaItemId);
    };

    swiper.on('slideChange', sync);
    sync();
  }

  /**
   * Swiper lo inicializa el JS del tema de forma diferida (import dinámico del
   * chunk), así que hay que esperar a que aparezca `el.swiper`.
   */
  function whenSwiperReady(carouselEl, callback) {
    if (carouselEl.swiper) {
      callback(carouselEl.swiper);
      return;
    }

    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;

      if (carouselEl.swiper) {
        clearInterval(timer);
        callback(carouselEl.swiper);
      } else if (attempts > 100) {
        clearInterval(timer);
      }
    }, 100);
  }

  function init(root) {
    (root || document).querySelectorAll(THUMBS).forEach(function (thumbsEl) {
      if (thumbsEl.dataset.carouselThumbsReady === 'true') return;

      var carouselEl = thumbsEl.previousElementSibling;
      while (carouselEl && !carouselEl.classList.contains('swiper')) {
        carouselEl = carouselEl.previousElementSibling;
      }
      if (!carouselEl) return;

      thumbsEl.dataset.carouselThumbsReady = 'true';
      whenSwiperReady(carouselEl, function (swiper) {
        connect(thumbsEl, swiper);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // El tema vuelve a pintar la columna izquierda al cambiar de variante y el
  // editor de temas recarga secciones completas.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  var rescan;
  new MutationObserver(function () {
    clearTimeout(rescan);
    rescan = setTimeout(function () {
      init();
    }, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
